const LOGO =
  "https://customer-assets.emergentagent.com/wingman/85cf05f2-d849-40c8-9fc9-80449c196070/attachments/71b336acd64a487ea8f6710e443d86c9_FullColor_TransparentBg_1280x1024_72dpi.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2D332B] text-[#F9F8F6] py-16 sm:py-20"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO}
                alt="Indoor Greens"
                className="h-10 w-auto object-contain brightness-0 invert opacity-90"
              />
              <span className="font-[Outfit] font-light tracking-[0.25em] text-xs uppercase">
                Indoor Greens
              </span>
            </div>
            <p className="mt-6 max-w-sm text-[14px] leading-relaxed text-[#B4C2AF]">
              The luxury biophilic design &amp; maintenance partner for
              considered commercial and residential interiors.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#B4C2AF] mb-5">
              Studio
            </p>
            <ul className="space-y-2 text-[14px] text-[#F9F8F6]/85">
              <li><a href="/#about" className="link-underline">About</a></li>
              <li><a href="/projects/design-mumbai-2025" className="link-underline">Design Mumbai 2025</a></li>
              <li><a href="/#bonsai" className="link-underline">Bonsai Atelier</a></li>
              <li><a href="/journal" className="link-underline">Journal</a></li>
              <li><a href="/#faq" className="link-underline">FAQ</a></li>
              <li><a href="/#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] tracking-[0.3em] uppercase text-[#B4C2AF] mb-5">
              Reach us
            </p>
            <ul className="space-y-2 text-[14px] text-[#F9F8F6]/85">
              <li>
                <a
                  href="tel:+917738035670"
                  data-testid="footer-phone"
                  className="link-underline"
                >
                  +91 77380 35670
                </a>
              </li>
              <li>
                <a
                  href="mailto:sujal@indoorgreens.in"
                  data-testid="footer-email"
                  className="link-underline"
                >
                  sujal@indoorgreens.in
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/indoorgreensin/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="link-underline"
                >
                  @indoorgreensin
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#F9F8F6]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[11px] tracking-[0.25em] uppercase text-[#B4C2AF]">
            © {year} Indoor Greens — All rights reserved
          </p>
          <p className="text-[11px] tracking-[0.25em] uppercase text-[#B4C2AF]">
            Mumbai · India
          </p>
        </div>
      </div>
    </footer>
  );
}
